module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_2.aca326e4.png";